intervals = {};

function open_form() {
  const template_link = new Request('/custom-template');
  fetch(template_link).then(resp => {
    resp.text().then(data => {
      const form = document.createElement('div');
      form.classList.add('template-form');
      form.innerHTML = data;
      document.querySelector('body').appendChild(form);
      const cancel_btn = form.querySelector('button');
      cancel_btn.innerHTML = 'Cancel';
      cancel_btn.addEventListener('click', function() {
        document.querySelectorAll('.overlay').forEach(elem => elem.remove());
        document.querySelectorAll('.template-form').forEach(elem => elem.remove());
      });
    });
    const overlay = document.createElement('div');
    overlay.classList.add('overlay');
    document.querySelector('body').appendChild(overlay);
  });
}

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('a').forEach(link => {
    if (link.href.split('#')[1] === 'create-event:template')
      link.addEventListener('click', open_form);
    if (link.href.split('#')[1] === 'create-event:lecture') {
      const dropdown = link.parentNode.parentNode;
      if (dropdown.classList.contains('i-dropdown')) {
        const template_button = document.createElement('li');
        template_button.innerHTML = `<a href="/#create-event:template" data-title="Create conference from template">From template</a>`;
        dropdown.insertBefore(template_button, link.parentNode);
        template_button.addEventListener('click', open_form);
      }
    }
  });


  document.addEventListener('keyup', e => {
    if (e.key === 'Escape') {
      document.querySelectorAll('.overlay').forEach(elem => elem.remove());
      document.querySelectorAll('.template-form').forEach(elem => elem.remove());
    }
  });

  if (window.location.hash === '#create-event:template')
    open_form();
});